// Copyright (c) Zammo Inc.
export const uuidv4 = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0,
      // eslint-disable-next-line no-bitwise
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/*!
 * The magic, find all occurences of `attr="/`, ignoring any `//` found,
 * ensure that the leading `/` of the url is not captured
 *
 * HTML attribute list from: http://stackoverflow.com/questions/2725156/complete-list-of-html-tag-attributes-which-have-a-url-value
 */

const rx =
  /((href|src|codebase|cite|background|cite|action|profile|formaction|icon|manifest|archive)=["'])(([.]+\/)|(?:\/)|(?=#))(?!\/)/g;

/*!
 * Match the same as above, but capture the full URL for iteration
 */

const captureRx =
  /((href|src|codebase|cite|background|cite|action|profile|formaction|icon|manifest|archive)=["'])((([.]+\/)|(?:\/)|(?:#))(?!\/)[a-zA-Z0-9._-]+)/g;

/**
 * URL replacement using function iteration, this is handled slightly
 * different as the user will be supplied with the full attribute value
 * for replacement, and will be inserted back correctly
 *
 * @param {String} html source
 * @param {Function} url iterator, called with (url, attributeName)
 * @return {String} replaced html source
 */

const iterate = (str: string, iterator: (a: string, b: string) => string) => {
  return str.replace(captureRx, (full, prefix, prop, url: string) => {
    return prefix + iterator(url, prop);
  });
};

/**
 * Replace all relative urls in a given HTML string with absolute
 *
 * @param {String} html source
 * @param {String} base url
 * @return {String} replaced html source
 */

export const htmlLinksAbsolutify = (str: string, url: string) => {
  if (typeof url === 'function') return iterate(str, url);
  return str.replace(rx, '$1' + url + '/$4');
};

export const forceToAppendHttps = (url: string) => {
  let value = url;
  if (value.startsWith('http://')) {
    value = value.replace('http://', 'https://');
  } else if (!value.startsWith('https://')) {
    value = 'https://' + value;
  }

  return value;
};

export const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
